import React from "react";
import { ScalableImage, Typography } from "design_system/src";
import { VehicleReview } from "models/inventory/interfaces/vehicle-review-data.interfaces";
import ReviewScore from "./ReviewScore";

interface ReviewCardProps {
  data: VehicleReview;
}

const formatDate = (date: string | Date) => {
  return new Intl.DateTimeFormat("es-ES", {
    day: "numeric",
    month: "long",
    year: "numeric"
  }).format(new Date(date));
};

const ReviewCard = ({ data }: ReviewCardProps) => {
  const {
    reviewerId,
    createdAt,
    reviewTitle,
    reviewContent,
    deliveryPhoto,
  } = data;
  return (
    <div className="dso_card display_flex_desktop flex_align_strench_desktop p_md m_b_lg">
      <div className="w_100_per h_200_px m_b_sm_mobile w_300_px_desktop h_250_px_desktop">
          <ScalableImage
          desktopWidth={20}
          mobileWidth={40}
          src={deliveryPhoto.url}
          alt={`Review de ${reviewerId.name} ${reviewerId.lastName}`}
          className="img_cover br_sm"
        />
      </div>
      <div className="flex_1_desktop m_l_xxl_desktop">
        <div className="text_center_mobile m_b_md display_flex_mobile flex_col_mobile flex_align_center_mobile">
          <Typography weight="600" scale="medium">
            {reviewerId.name} {reviewerId.lastName}
          </Typography>

          <div>
            <ReviewScore value={data.getGlobalRating()} />
          </div>

          <Typography weight="400" scale="small" className="text_neutral_500">
            {formatDate(createdAt)}
          </Typography>
        </div>


        <Typography weight="600" scale="small" className="m_b_md">
          {`"${reviewTitle}"`}
        </Typography>

        <Typography weight="400" scale="small">
          {reviewContent}
        </Typography>
      </div>
    </div>
  );
};

export default ReviewCard;
